import Vue from 'vue';
import Vuex from 'vuex';

import auth from './modules/auth';
import app from './modules/app';
import user from './modules/user';
import gloading from './modules/gloading';

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    app,
    auth,
    user,
    gloading
  }
});
